import core from './commuCore'
const output = {}

/* —————————————————————— 个人相关api —————————————————————— */

function addNewIndividual (Individual) {
  return core.ajax(Individual, '/individual', 'post')
}
output.addNewIndividual = addNewIndividual

function getIndividualPage (query) {
  return core.ajax(query, '/individual', 'get')
}
output.getIndividualPage = getIndividualPage

function deleteIndividual (condition) {
  return core.ajax(condition, '/individual', 'delete')
}
output.deleteIndividual = deleteIndividual

function updateIndividual (condition) {
  return core.ajax(condition, '/individual', 'put')
}
output.updateIndividual = updateIndividual

function findTeam (condition) {
  return core.ajax(condition, '/individual/team', 'get')
}
output.findTeam = findTeam

function findIndividualName (condition) {
  return core.ajax(condition, '/individual/name', 'get')
}
output.findIndividualName = findIndividualName

export default output
